import { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Spinner } from "src/components";
import { employeeActions } from "src/context/employee-slice";
import { ordActions } from "src/context/order-slice";
import { RootState } from "src/context/store";
import { TimeLineChip } from "src/features/fields/components/TimeLineChip";
import { useToast } from "src/hooks/useToast";
import { getOrderApprovalHierarchy } from "src/services/order-api";
import { queryEmployeeDetails } from "src/services/employee-api";

const OrderInfoApprovalHierarchy = () => {
  const { approvalHierarchy } = useSelector((state: RootState) => state.ord);
  const { orderDetailsFiltered } = useSelector((state: RootState) => state.ord);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const orderDetails = orderDetailsFiltered?.[0];

  const { toast } = useToast();

  //M10-14597
  const handleEmployeeClick = (actor_short_code: any, company_id: any) => {
    if (!actor_short_code) return;
    // Open window synchronously to avoid popup blockers, redirect after empmaster_id resolves
    const newWindow = window.open("", "_blank");
    const companyParam = company_id ? `&company_id=${encodeURIComponent(company_id.toString())}` : "";
    queryEmployeeDetails(`/details?search=${encodeURIComponent(actor_short_code.toString())}&perPage=1&page=1${companyParam}`)
      .then((res) => {
        const empmaster_id = res?.data?.data?.[0]?.empmaster_id;
        if (empmaster_id && newWindow) {
          newWindow.sessionStorage.setItem("employeeId", empmaster_id.toString());
          if (company_id) newWindow.sessionStorage.setItem("employeeCompanyId", company_id.toString());
          else newWindow.sessionStorage.removeItem("employeeCompanyId");
          dispatch(employeeActions.setEmployeeSelectedData({}));
          newWindow.location.href = "/masters/employees/details";
        } else if (newWindow) {
          newWindow.location.href = "/masters/employees";
        }
      })
      .catch(() => {
        if (newWindow) newWindow.location.href = "/masters/employees";
      });
  };
  //M10-14597

  //M10-15598
  const isCounterCode = (code: any) => /^DR\d+/i.test(code?.toString() ?? "");

  const handleCounterClick = (counter_code: any) => {
    if (!counter_code) return;
    window.open(`/masters/counters/details/?counter_code=${encodeURIComponent(counter_code.toString())}`, "_blank", "noopener,noreferrer");
  };
  //M10-15598

  useEffect(() => {
    const fetchApprovalHierarchy = async () => {
      try {
        setIsLoading(true);
        const response = await getOrderApprovalHierarchy(orderDetails?.order_id_int, orderDetails?.company_code);
        dispatch(ordActions.setApprovalHierarchy(response?.data?.data?.data));
        toast({ description: "Approval Hierarchy fetched successfully", variant: "default" });
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
        toast({ description: "Failed to fetch hierarcy", variant: "destructive" });
      }
    };
    dispatch(ordActions.setApprovalHierarchy([]));
    fetchApprovalHierarchy();
  }, [orderDetails]);

  return (
    <div className="w-full mx-auto shadow-sm border border-[#D0D0D0] rounded-xl p-2 bg-white">
      {isLoading ? (
        <div className="flex justify-center items-center h-[50vh]">
          <Spinner />
        </div>
      ) : approvalHierarchy?.length && approvalHierarchy?.length > 0 ? (
        <div className="pb-4 px-6 overflow-y-auto">
          {approvalHierarchy?.map((item: any) => {
            if (item?.operation_list?.length === 1 && item?.operation_list?.[0]?.toString()?.toLowerCase() === "viewer") return <></>;
            return (
              <Fragment key={item?.order_status_id}>
                <TimeLineChip
                  title={item?.ff_level}
                  name={item?.actor_name}
                  location={item?.actor_short_code}
                  dateTime={item?.modified_date}
                  status={item?.operation_status}
                  preq_status={item?.operation_status}
                  onLocationClick={
                    item?.actor_short_code
                      ? isCounterCode(item?.actor_short_code) //M10-15598
                        ? () => handleCounterClick(item?.actor_short_code) //M10-15598
                        : () => handleEmployeeClick(item?.actor_short_code, orderDetails?.company_code)
                      : undefined
                  } //M10-14597
                />
              </Fragment>
            );
          })}
        </div>
      ) : (
        <h1 className="text-center text-gray-500 text-lg h-[50vh] flex items-center justify-center">No hierarchy found</h1>
      )}
    </div>
  );
};

export default OrderInfoApprovalHierarchy;
